import styles from "./styles.module.css";

export const SidebarHeading = ({ children }) => {
  return <h2 className={styles.sidebarHeading}>{children}</h2>
};

export default SidebarHeading;
